module.exports = __webpack_public_path__ + "img/transparent.905b9cd9.png";